import { Button, COLORS, NAME_SOUND_HOVER, useGameSounds, useTranslate } from "@educaplay/core";
import { Check } from "@educaplay/core/Icons/Check";
import { useEffect, useRef } from "react";
import classes from "./NormalInput.module.scss";
import clsx from 'clsx';



export default function NormalInput(props) {

    const { onChangeHandler, inputValue, inputDisabled, isInputEmpty, soundInputHandler } = props;
    const inputRef = useRef();
    const gameSound = useGameSounds();
    const t = useTranslate();

    useEffect(() => {
        setTimeout(() => {
            inputRef.current?.focus();
        });
    }, [])

    return (
        <>
            <input
                type="text"
                name='options'
                onChange={onChangeHandler}
                ref={inputRef}
                className={classes.input}
                value={inputValue}
                disabled={inputDisabled}
                onKeyDown={soundInputHandler}
            />
            <Button type={"submit"}
                icon={<Check color={COLORS.primaryDark2} />}
                className={clsx(classes.sendButtonDesktop, isInputEmpty && classes.sendButtonDesktopDisabled)}
                disabled={isInputEmpty || inputDisabled}
                onMouseEnter={() => gameSound.play(NAME_SOUND_HOVER)}
            >
                {t('common.settings.accept')}
            </Button>
        </>
    )
}